import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { apiErrorClear } from '../../../../global/ducks/base-api';
import { useQuery } from '../../../../global/hooks/useQuery';
import { DemographicsContext } from '../../../../global/models/demographics-model';
import { Person } from '../../../../global/models/person-model';
import { TcsmEpiApiState, TcsmStates } from '../../../../root/tcsm-model';
import { AnnualEnrollmentContext } from '../../../annual-enrollment/models/annual-enrollment-models';
import { useDependents } from '../../hooks/useDependents';
import { setDocumentUploadStatus } from '../personal-info/document-upload-slice';
import { DeathOfChildForm } from './death-of-child-form';
import { DeathOfChildWizard } from './wizard/death-of-child-wizard';

interface Props {	
	customWizard?: DeathOfChildWizard;
}
function DeathOfChildApp(props: Props) {
	const { customWizard } = props;	
	const app = useContext(DemographicsContext);
	const context = useContext(AnnualEnrollmentContext);
	const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const currentPerson = useSelector<TcsmStates, Person>(state => state.personalInfo[app]?.currentPerson);
	const personGuid = currentPerson?.person_guid;
	const dependentsLoaded = useDependents(personGuid);	
	
	const action = useQuery()?.get('action');
	const history = useHistory();
	const dispatch = useDispatch();
	const wizard = customWizard ?? new DeathOfChildWizard(epiProps, context, app, dispatch, history, action, currentPerson);
	useEffect(() => {
		dispatch(apiErrorClear());
		dispatch(setDocumentUploadStatus(false, app));
	}, []);

	if (!dependentsLoaded) {
		return <LoadingCircle />;
	}

	return (		
		<DeathOfChildForm wizard={wizard} />		
	);
}

DeathOfChildApp.defaultProps = {	
	customWizard: null,
};


export default DeathOfChildApp;